import {Text, View} from "@react-pdf/renderer";
import React, {useContext} from "react";

import { baseStyles } from "../styles";
import {PDFContext} from "../BasePDF";

export const FeeBreakdownPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null;

    const fees = pdfData.fees

    return (
        <View style={{...baseStyles.table}} wrap={false}>
            <View style={{...baseStyles.tableHeader, backgroundColor: pdfData.pageColor}}>
                <Text>Fee Breakdown</Text>
            </View>

            {/*<View style={{...baseStyles.flexBetween}}>*/}
            {/*    <Text>*/}
            {/*        Type*/}
            {/*    </Text>*/}

            {/*    <Text>*/}
            {/*        Amt*/}
            {/*    </Text>*/}
            {/*</View>*/}
            <View>
                {/*<View style={{...baseStyles.flexBetween}}>*/}
                {/*    <Text>*/}
                {/*        Registration Fees*/}
                {/*    </Text>*/}
                {/*    <Text>*/}
                {/*        /!*{ helper.registrationFeeAmount().toDollarFormat() }*!/*/}
                {/*    </Text>*/}
                {/*</View>*/}
                {
                    fees.map((t) => {
                        return (
                            <View
                                key={t.id}
                                style={{...baseStyles.flexBetween}}
                            >
                                <Text>
                                    {t.name}
                                </Text>
                                <Text>
                                    {t.amount.toDollarFormat()}
                                </Text>
                            </View>
                        )
                    })
                }
                <View
                    style={{...baseStyles.boldTopBorder, ...baseStyles.flexBetween}}
                >
                    <Text>
                        Total Fees
                    </Text>
                    <Text>
                        {pdfData.total_fees.toDollarFormat()}
                    </Text>
                </View>
            </View>
        </View>
    )
}